import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';
const initialState = {
  editSubjectData: null,
  isAddSubjectModalOpen: false,
  subjectMetaData: null,
};

const SubjectsSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {
    setEditSubjectData: (state, action: PayloadAction<any>) => {
      state.editSubjectData = action.payload;
    },

    setIsAddSubjectModalOpen: state => {
      state.isAddSubjectModalOpen = !state.isAddSubjectModalOpen;
    },
    setSubjectMetaData: (state, action: PayloadAction<any>) => {
      state.subjectMetaData = action.payload;
    },
  },
});

export const selectisAddSubjectModalOpen = (state: RootState) =>
  state.subject.isAddSubjectModalOpen;

export const selectEditSubjectData = (state: RootState) =>
  state.subject.editSubjectData;

export const selectSubjectMetaData = (state: RootState) =>
  state.subject.subjectMetaData;

export const {
  setEditSubjectData,
  setIsAddSubjectModalOpen,
  setSubjectMetaData,
} = SubjectsSlice.actions;
export default SubjectsSlice.reducer;
